<template lang="html">
    <div>
        <div class="row text-center my-3 action-button pt-4">
            <label class="col-lg-6 col-md-8 col-xs-12 col-12 radio radio-before pb-3">
                <span class="radio__input">
                    <input type="radio" dusk="juridical-person" :checked="profile.billing_type == 'pj'" v-on:click="$emit('resetErrors');profile.billing_type = 'pj'"/>
                    <span class="radio__control"></span>
                </span>
                <span class="radio__label">{{ $t('juridical_person') }}</span>
            </label>
            <label class="col-lg-6 col-md-8 col-xs-12 col-12 radio radio-before pb-3">
                <span class="radio__input">
                    <input type="radio" dusk="person" :checked="profile.billing_type == 'pf'" v-on:click="$emit('resetErrors');profile.billing_type = 'pf'"/>
                    <span class="radio__control"></span>
                </span>
                <span class="radio__label">{{ $t('individual_person') }}</span>
            </label>
        </div>

        <template v-if="profile.billing_type == 'pj'">
            <div class="form-group" v-if="countries">
                <label for="taraInmatriculare2" class="input-text">{{ $t('label_country') }}*</label>
                <select class="form-control" id="taraInmatriculare2" v-model="profile.country" @change="validate()">
                    <option v-for="c in countries" :key="c.id" :value="c.id">{{c.country}}</option>
                </select>
            </div>
            <div class="d-flex align-items-end p-0" :class="isDesktop()? 'pr-4':''">
                <div class="mr-3">
                    <div class="form-group m-0">
                        <label for="cui" class="input-text">{{ $t('label_cui') }}*</label>
                        <span v-if="errorMsgs.fiscal_code" class="invalid-feedback">
                           {{errorMsgs.fiscal_code}}
                        </span>
                        <input dusk="cui" type="text" class="form-control p-4" v-model="profile.fiscal_code" :class="{'has-error': errorMsgs.fiscal_code}" v-on:blur="getTermene()" v-on:focus="hideVerifiedStatus()" v-on:keyup="validateROCui(profile)">
                    </div>
                </div>
                <div class="text-right " :class="isDesktop() ? 'ml-1' : ''" v-if="profile.country == 1 && !manualProfileCompletion">
                    <button dusk="verify-cui" class="main-btn" v-on:click="getTermene()" :disabled="!profile.fiscal_code">{{ $t('btn_verify') }}</button>
                </div>
            </div>
            <div>
                <div id="recaptcha-error" class="alert alert-danger text-center mt-3" v-if="recaptchaError != null">
                    {{ recaptchaError }}
                </div>
                <div id="recaptcha-container"></div>
            </div>
            <div class="d-flex mt-2">
                <template v-if="!manualProfileCompletion && profile.country == 1">
                    <div class="icon warning-icon mr-2"></div>
                    <p>{{ $t('auto_query_company_data') }}</p>
                </template>
            </div>
            <template v-if="profile.country == 1 && profile.fiscal_code && showVerifiedStatus && !loadingTermene">
                <div class="text-success mb-4 input-text" v-if="profile.validated_cui && !manualProfileCompletion">
                    {{ $t('verified_company_data') }}
                </div>
                <div class="text-warning mb-4 input-text" v-else>
                    <template v-if="manualProfileCompletion">
                        {{ $t('unverified_company_data_with_manual_completion') }}
                    </template>
                    <template v-else>
                        {{ $t('unverified_company_data') }}
                    </template>
                </div>
            </template>
            <div class="text-center mt-4" v-if="loadingTermene">
                <van-loading type="spinner" color="#1989fa" />
            </div>
            <template>
                <div class="form-group" :class="{'mt-3': manualProfileCompletion}">
                    <label for="company" class="input-text autocompleted">{{ $t('label_company_name') }}*</label>
                    <span v-if="errorMsgs.company" class="invalid-feedback">
                        {{errorMsgs.company}}
                    </span>
                    <input type="text" id="company" :disabled="!manualProfileCompletion && profile.country == 1" v-model="profile.company" :class="{'has-error': errorMsgs.company}" class="form-control p-4 w-100" @change="validate()">
                </div>
                <div class="form-group wi-75">
                    <label for="regcom" class="input-text autocompleted w-100">{{ $t('label_reg_com') }}*</label>
                     <span v-if="errorMsgs.j_code" class="invalid-feedback">
                        {{errorMsgs.j_code}}
                    </span>
                    <input type="text" id="regcom" :disabled="!manualProfileCompletion && profile.country == 1 && !requiredManualInput('j_code')" v-model="profile.j_code" :class="{'has-error': errorMsgs.j_code}" class="form-control p-4" @change="validate()">
                </div>
                <div class="form-group wi-75">
                    <label for="city1" class="input-text autocompleted w-100">{{ $t('label_locality') }}*</label>
                    <span v-if="errorMsgs.city" class="invalid-feedback">
                        {{errorMsgs.city}}
                    </span>
                    <input type="text" id="city1" :disabled="!manualProfileCompletion && profile.country == 1 && !requiredManualInput('city')" v-model="profile.city" :class="{'has-error': errorMsgs.city}" class="form-control p-4" @change="validate()">
                </div>
                <div class="form-group">
                    <label for="address1" class="input-text autocompleted">{{ $t('label_address') }}*</label>
                    <span v-if="errorMsgs.address" class="invalid-feedback">
                        {{errorMsgs.address}}
                    </span>
                    <textarea type="text" id="address1" :disabled="!manualProfileCompletion && profile.country == 1 && !requiredManualInput('address')" v-model="profile.address" :class="{'has-error': errorMsgs.address}" class="form-control p-4 w-100" @change="validate()"></textarea>
                </div>
            </template>
        </template>

        <template v-if="profile.billing_type == 'pf'">
            <div class="form-group">
                <label for="last_name" class="input-text">{{ $t('label_last_name') }}*</label>
                <span v-if="errorMsgs.last_name" class="invalid-feedback">
                    {{errorMsgs.last_name}}
                </span>
                <input id="last_name" class="form-control p-4" type="text" @input="validate" v-model="profile.last_name" :class="{'has-error': errorMsgs.last_name}">
            </div>
            <div class="form-group">
                <label for="first_name" class="input-text">{{ $t('label_first_name') }}*</label>
                <span v-if="errorMsgs.first_name" class="invalid-feedback">
                    {{errorMsgs.first_name}}
                </span>
                <input id="first_name" class="form-control p-4" type="text" @input="validate" v-model="profile.first_name" :class="{'has-error': errorMsgs.first_name}">
            </div>
            <div class="form-group" v-if="countries">
                <label for="taraInmatriculare" class="input-text">{{ $t('label_country') }}*</label>
                <select class="form-control" id="taraInmatriculare" @change="validate" v-model="profile.country" :class="{'has-error': errorMsgs.country}">
                    <option v-for="c in countries" :value="c.id">{{c.country}}</option>
                </select>
            </div>
            <div class="form-group" v-if="counties && profile.country == 1">
                <label for="county" class="input-text">{{ $t('label_county') }}*</label>
                <span v-if="errorMsgs.county" class="invalid-feedback">
                    {{errorMsgs.county}}
                </span>
                <select dusk="country" class="form-control" id="county" v-model="profile.county" @change="validate" :class="{'has-error': errorMsgs.county}">
                    <option v-for="c in counties" :value="c.id">{{c.name}}</option>
                </select>
            </div>
            <div class="form-group">
                <label for="city" class="input-text">{{ $t('label_city') }}*</label>
                <span v-if="errorMsgs.city" class="invalid-feedback">
                    {{errorMsgs.city}}
                </span>
                <input id="city" class="form-control p-4" type="text" @input="validate" v-model="profile.city" :class="{'has-error': errorMsgs.city}">
            </div>
            <div class="form-group">
                <label for="address" class="input-text">{{ $t('label_address') }}</label>
                <span v-if="errorMsgs.address" class="invalid-feedback">
                    {{errorMsgs.address}}
                </span>
                <textarea dusk="address" type="text" @input="validate" v-model="profile.address" class="form-control p-4" :class="{'has-error': errorMsgs.address}"></textarea>
            </div>
        </template>
    </div>
</template>

<script>

import { mapActions, mapState, mapGetters } from 'vuex'
import loadRecaptcha from '../mixins/loadRecaptcha'

export default {
    name: 'BillingProfile',
    mixins: [
        loadRecaptcha
    ],
    components: {
    },
    data: function() {
        return {
            profile: {
                billing_type: 'pj',
                first_name: '',
                last_name: '',
                address: '',
                country: 1,
                county: '',
                company: '',
                j_code: '',
                city: '',
                fiscal_code: '',
                validated_cui: false,
            },
            termene: null,
            throttlingTermene: false,
            showVerifiedStatus: true,
            loadingTermene: false,
            valid: false,
            manualInput: [],
            recaptchaError: null
        }
    },
    props: {

        value: {

            type: Object,
            default: function() {

                return {
                    billing_type: 'pj',
                    first_name: '',
                    last_name: '',
                    address: '',
                    country: 1,
                    city: '',
                    county: '',
                    company: '',
                    j_code: '',
                    fiscal_code: '',
                    validated_cui: false,
                }
            }
        },
        errorMsgs: {

            type: Object,
            default: function() {

                return {
                    first_name: '',
                    last_name: '',
                    address: '',
                    country: '',
                    county: '',
                    company: '',
                    j_code: '',
                    fiscal_code: '',
                    email: ''
                }
            }
        },

        mode: {
            type: String,
            default: 'add'
        }
    },
    computed: {
        ...mapState('countries', [
            'countries'
        ]),
        ...mapState('counties', [
            'counties'
        ]),
        ...mapGetters({
            tmpProfile: 'profiles/getTmpProfile',
            manualProfileCompletion: 'profiles/getManualProfileCompletion',
            getRecaptchaToken: 'recaptcha/getToken',
            getRecaptchaTokenType: 'recaptcha/getType'
        }),
    },
    mounted() {
        this.init();
    },
    watch: {

        profile: {
            handler() {
                this.$emit('input', {
                    profile: this.profile
                })
            },
            deep: true
        },

        'profile.country': function(newVal, oldVal) {
            this.validateROCui(this.profile)
        },

        'profile.billing_type': function() {
            this.clearErrors(this.errorMsgs)
        },

        valid: function(newVal) {
            this.$emit('verifiedStatus', newVal);
        },

        'profile.billing_type': function() {
            this.validate();
        }
    },
    methods: {

        ...mapActions({
            setManualProfileCompletion: 'profiles/setManualProfileCompletion',
            getCountries: 'countries/getCountries',
            getCounties: 'counties/getCounties'
        }),

        copyValueIntoProfile() {
            this.profile.billing_type = this.value.billing_type;
            this.profile.last_name = this.value.last_name;
            this.profile.first_name = this.value.first_name;
            this.profile.country = this.value.country;
            this.profile.county = this.value.county;
            this.profile.city = this.value.city;
            this.profile.address = this.value.address;

            if(this.value.billing_type == 'pj') {
                this.profile.fiscal_code = this.value.fiscal_code;
                this.profile.company = this.value.company;
                this.profile.j_code = this.value.j_code;
                this.profile.validated_cui = true;
            }
        },

        init() {

            this.getCountries();
            this.getCounties();

            if(this.tmpProfile != null) {
                this.profile = this.tmpProfile;
                this.validate();
                this.getTermene();
            }
            else {
                this.copyValueIntoProfile();
            }

            this.$emit('input', {
                profile: this.profile
            });
        },

        hideVerifiedStatus()
        {
            this.showVerifiedStatus = false;
        },

        async getTermene()
        {
            if(this.manualProfileCompletion) {
                return;
            }

            await this.checkRecaptcha();

            this.showVerifiedStatus = true;

            this.clearErrors(this.errorMsgs);

            if(!this.profile.fiscal_code) {
                return false;
            }

            if(this.throttlingTermene) {
                return false;
            }

            if(this.profile.country != 1) {
                return false;
            }

            this.throttlingTermene = true;
            this.loadingTermene = true;

            let recaptchaToken = this.getRecaptchaToken;
            let recaptchaVersion = this.getRecaptchaTokenType;

            this.$axios.get('/termene/' + this.profile.fiscal_code, 
                { 
                    headers: { [`G-Recaptcha-${recaptchaVersion}-Token`]: recaptchaToken 
                }
            }).then(response => {
                if(response.data.termene) {
                    this.termene = response.data.termene;

                    this.profile.company = this.termene.nume;
                    this.profile.j_code = this.termene.regcom;
                    this.profile.fiscal_code = this.termene.cui;
                    this.profile.city = this.termene.localitate;
                    this.profile.address = this.termene.adresa;
                    this.profile.county = this.termene.judet_id;

                    this.checkIfManualInputRequired();

                    this.profile.validated_cui = 1;
                    this.validate();
                }

                this.throttlingTermene = false;
                this.loadingTermene = false;
            }).catch(err => {
                this.throttlingTermene = false;
                this.loadingTermene = false;

                if(err?.response?.data?.error?.error_code == 'recaptcha') {
                    this.tryWithCaptchaVersion('v2');
                    this.loadRecaptchaV2();
                    this.recaptchaError = err.response.data.error.error_msg;
                    
                    return;
                }

                if(err.response.status == 408) {
                    //trigger manual completion of data
                    this.setManualProfileCompletion(true);
                    this.validate();
                }
                else {
                    this.profile.company = '';
                    this.profile.j_code = '';
                    this.profile.fiscal_code = '';
                    this.profile.city = '';
                    this.profile.address = '';
                    this.profile.county = '';
                    this.profile.validated_cui = false;
                }

                if(err.response) {
                    this.$dialog.alert({
                        'message': err.response.data.error.error_msg,
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                }
            });
        },

        checkIfManualInputRequired() {
            this.manualInput = [];
            for(let key in this.profile) {
                let value = this.profile[key];
                if(typeof value == 'string' && !value.trim()) {
                    if(!this.manualInput.includes(key)) {
                        this.manualInput.push(key);
                    }
                }
            }
        },

        requiredManualInput(key) {
            return this.manualInput.includes(key);
        },

        calcIsValidatedCui()
        {
            let validated = true;

            if((!this.termene && this.profile.country == 1) && this.mode == 'add') {
                this.profile.validated_cui = false;
                return;
            }

            if(!this.profile.company) {
                validated = false;
            }
            if(!this.profile.j_code) {
                validated = false;
            } 
            if(!this.profile.fiscal_code) {
                validated = false;
            }
            if(!this.profile.city) {
                validated = false;
            }

            //If the country is Romania, then we check county
            if(this.profile.country == 1) {
                if(!this.profile.county) {
                    validated = false;
                }
            }

            if(!this.profile.address) {
                validated = false;
            }

            this.profile.validated_cui = validated;
        },

        validate() {
            if(this.profile.billing_type == 'pj') {
                this.calcIsValidatedCui();
                this.valid = this.profile.validated_cui;
            }
            else {
                this.valid = this.isPFValid();
            }
        },

        isPFValid() {
            let valid = true;

            if(!this.profile.last_name || !this.profile.last_name.length) {
                valid = false;
            }

            if(!this.profile.first_name || !this.profile.first_name.length) {
                valid = false;
            }

            if(!this.profile.country) {
                valid = false;
            }

            if(this.profile.country == 1 && !this.profile.county) {
                valid = false;
            }

            if(!this.profile.city) {
                valid = false;
            }

            return valid;
        }
    }
}

</script>

<style lang="scss" scoped>

$lightgrey: lightgrey;
$green: #59af54;

*,
*:before,
*:after {
  box-sizing: border-box;
}

.input-text{

    font-size: 18px;
    font-weight: 500;
}
.autocompleted{
    color: #737880;
}

.radio {
  display: flex;
  font-size: 18px;
}

.radio__label {
  line-height: 1;
  transition: 180ms all ease-in-out;
  opacity: 1;
  cursor: pointer;
}

.radio__input {
    display: flex;
    margin-right:5px;
    input {
        opacity: 0;
        width: 0;
        height: 0;

  }
}

.radio-before {
  .radio__control {
    display: grid;
    place-items: center;
  }

  input + .radio__control::before {
    content: "";
    width: 0.6em;
    height: 0.6em;
    box-shadow: inset 0.5em 0.5em currentColor;
    border-radius: 50%;
    transform: scale(0);
    background: #0F2443;
    cursor: pointer;
  }

  input:checked + .radio__control::before {
    transform: scale(1);
  }
}

.radio__control {
  display: block;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  border: 0.1em solid currentColor;
  transform: translateY(-0.05em);
}
.or {
    padding-top: 71px;
    margin-right: 20px;
    color: #737880;
}
.ancillary {
    color: #DCCCCD;
}

.wi-75 {
    @media only screen and (max-width: 767px) {
        width: 100%;
    }

    @media only screen and (min-width: 768px) {
        width: 75%;
    }
}

</style>
